import { useState } from 'react';

const PHOTOS = [
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/28417a2a3e28f1a08e7d2551b2e866cb.jpeg',
    alt: 'Навес с красным поликарбонатом и коваными воротами',
    caption: 'Навес с поликарбонатом и кованые ворота',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/e5d5f6e1140ccb6808d0377e85ebc938.jpeg',
    alt: 'Арочный навес с красным поликарбонатом',
    caption: 'Арочный навес с красным поликарбонатом',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/c990dc13f54f3d235baa02667d00a983.jpeg',
    alt: 'Большой арочный навес для нескольких автомобилей (машин)',
    caption: 'Большой арочный навес — 3 машины',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/2b44b789bc8ad05370868ecba9db3750.jpeg',
    alt: 'Навес с кованым декором зимой над автомобилем',
    caption: 'Навес с кованым фризом — защита от снега',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/d080ef9217c21f7b9e54ef55ebb921f4.jpeg',
    alt: 'Большой навес с кованым декором в процессе монтажа',
    caption: 'Навес на несколько машин — монтаж',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/9e2eee66e22cc3c3f80226805fb3deb6.jpeg',
    alt: 'Двускатный кованый навес у гаража',
    caption: 'Двускатный навес с кованым фронтоном',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/0327167a900657acca30c56dc307db70.jpeg',
    alt: 'Навес с кованым декором над въездом в гараж',
    caption: 'Навес с поликарбонатом над гаражом',
  },
];

export default function GallerySection() {
  const [lightbox, setLightbox] = useState<number | null>(null);

  const prev = () => setLightbox((p) => (p === null ? null : p === 0 ? PHOTOS.length - 1 : p - 1));
  const next = () => setLightbox((p) => (p === null ? null : p === PHOTOS.length - 1 ? 0 : p + 1));

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Наши работы
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Реальные навесы, изготовленные и&nbsp;смонтированные нашей командой
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {PHOTOS.map((photo, idx) => (
            <div
              key={photo.src}
              className="relative overflow-hidden rounded-lg cursor-pointer group"
              style={{ aspectRatio: '4/3' }}
              onClick={() => setLightbox(idx)}
            >
              <img
                src={photo.src}
                alt={photo.alt}
                className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p className="text-background-50 text-xs font-medium">{photo.caption}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA under gallery */}
        <div className="text-center mt-10">
          <a
            href="https://max.ru/u/f9LHodD0cOICoHyOC2LT2Vx_42oC8Zdm2VV9Uv5O-6mGvkZgeZzUcJQkER0"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm px-7 py-3.5 rounded-md transition-all duration-300 hover:scale-[1.03] cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-image-line text-base"></i>
            </span>
            Хочу такой же — обсудить проект
          </a>
        </div>
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 backdrop-blur-sm"
          onClick={() => setLightbox(null)}
        >
          <button
            onClick={(e) => { e.stopPropagation(); prev(); }}
            className="absolute left-4 md:left-8 w-10 h-10 flex items-center justify-center bg-background-50/10 hover:bg-background-50/25 text-background-50 rounded-full transition-all duration-300 cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>

          <div
            className="relative max-w-4xl w-full mx-4 md:mx-16"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={PHOTOS[lightbox].src}
              alt={PHOTOS[lightbox].alt}
              className="w-full max-h-[80vh] object-contain rounded-lg"
            />
            <p className="text-background-50/80 text-sm text-center mt-3">{PHOTOS[lightbox].caption}</p>
            <span className="absolute top-3 right-3 text-background-50/60 text-xs">
              {lightbox + 1} / {PHOTOS.length}
            </span>
          </div>

          <button
            onClick={(e) => { e.stopPropagation(); next(); }}
            className="absolute right-4 md:right-8 w-10 h-10 flex items-center justify-center bg-background-50/10 hover:bg-background-50/25 text-background-50 rounded-full transition-all duration-300 cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>

          <button
            onClick={() => setLightbox(null)}
            className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-background-50/10 hover:bg-background-50/25 text-background-50 rounded-full transition-all duration-300 cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
      )}
    </section>
  );
}